import ArrowBack from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAtom, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import * as state from '@/components/Analysis/state';
import * as poiState from '../state';
import { SelectedTab } from '@/types';
import { abyssColors } from '@/theme/colors';
import { SxProps } from '@mui/material';

type AllEquipmentBackButtonProps = {
  changeTab: (selectedTabIndex: number) => void;
  retainAssemblyView?: boolean;
  customLabel?: string;
  sx?: SxProps;
};

export const AllEquipmentBackButton = ({
  changeTab,
  customLabel,
  retainAssemblyView = false,
  sx = {},
}: AllEquipmentBackButtonProps) => {
  const setSelectedSpherical = useSetAtom(state.selectedSpherical);
  const setHoveredAssemblyId = useSetAtom(state.hoveredAssemblyId);
  const setSelectedAssemblyInfo = useSetAtom(state.selectedAssemblyInfo);
  const [selectedAssemblyId, setSelectedAssemblyId] = useAtom(state.selectedAssemblyId);
  const cancelPOIAdd = useSetAtom(poiState.cancelPOIAdd);
  const setCameraTarget = useSetAtom(state.cameraTarget);
  const setSelectedAssemblyName = useSetAtom(state.selectedAssemblyName);

  const clickHandler = useCallback(() => {
    if (!retainAssemblyView) {
      setSelectedSpherical(undefined);
      setHoveredAssemblyId(undefined);
    }
    setSelectedAssemblyName(undefined);
    setCameraTarget(undefined);
    cancelPOIAdd();
    setSelectedAssemblyId(undefined);
    setSelectedAssemblyInfo(undefined);
    changeTab(SelectedTab.COMPONENT);
  }, [
    retainAssemblyView,
    setSelectedAssemblyName,
    setCameraTarget,
    cancelPOIAdd,
    setSelectedAssemblyId,
    setSelectedAssemblyInfo,
    changeTab,
    setSelectedSpherical,
    setHoveredAssemblyId,
  ]);

  if (!selectedAssemblyId) return <></>;

  return (
    <Box
      data-testid="equipment-back-button"
      onClick={clickHandler}
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: '3.2rem',
        mb: '2.4rem',
        mx: '2rem',
        cursor: 'pointer',
        ...sx,
      }}
    >
      <ArrowBack sx={{ color: abyssColors.primary[500], fontSize: '1.8rem' }} />
      <Typography
        fontSize="1.4rem"
        lineHeight="normal"
        fontWeight={500}
        sx={{ ml: 1 }}
        color={abyssColors.primary[500]}
      >
        {customLabel || 'All Components'}
      </Typography>
    </Box>
  );
};
